var _defs, _g, _g2, _polygon, _polygon2, _polygon3, _script;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 363.89 59.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#f25822;}.cls-3{fill:#342c2a;}.cls-4{fill:#111;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.74,21.84l3.92-7.72h3.82l-5.55,10.2,5.55,10H88.66l-3.92-7.57-3.95,7.57H77l5.64-10L77,14.12h3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.61,34.35V14.12H99v17h7.51v3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.9,34.09a45.1,45.1,0,0,1-5.58.58c-5.88,0-7.37-3.57-7.37-10.41,0-7.31,1.87-10.46,7.37-10.46a35.3,35.3,0,0,1,5.61.67l-.11,3s-3.51-.41-5-.41c-3.31,0-4.3,1.84-4.3,7.19,0,5.09.79,7.14,4.42,7.14,1.34,0,4.91-.38,4.91-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.47,24.38c0-6.84,2.11-10.58,8-10.58s8,3.74,8,10.58-2.1,10.29-8,10.29S131.47,31.22,131.47,24.38Zm12.49,0c0-5-1.11-7.43-4.48-7.43S135,19.38,135,24.38s1.08,7.13,4.47,7.13S144,29.44,144,24.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.32,14.12h5.76l6,16.66h.41V14.12H167V34.35h-5.64l-6.17-16.66h-.41V34.35h-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.39,17.36s-4-.41-5.7-.41c-2.17,0-3.45.79-3.45,2.49s1,2.34,4.24,3.39c4.09,1.4,5.58,2.31,5.58,5.7,0,4.24-2.05,6.14-6.75,6.14a41.44,41.44,0,0,1-6.17-.64l.17-3s3.86.43,5.71.43c2.3,0,3.65-.73,3.65-2.86,0-1.49-1.08-2-4-3-4.3-1.43-5.79-2.75-5.79-6.17,0-3.77,2.39-5.7,6.63-5.7a36.36,36.36,0,0,1,6,.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.08,14.12h13.68v3.3h-5.08V34.35h-3.39V17.42h-5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.35,27.33h-3.57v7h-3.39V14.12h7.28c4.42,0,6.84,2,6.84,6.52,0,3-1.08,4.79-3.15,5.85l3.15,7.86h-3.77l-2.75-7Zm.32-10h-3.89v7h3.95c2.13,0,3.27-1.55,3.27-3.56A3.12,3.12,0,0,0,208.67,17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.41,31.34c2.63,0,3.86-1,3.86-3.51V14.12h3.42V27.83c0,4.79-2.19,6.78-7.28,6.78s-7.25-2-7.25-6.78V14.12h3.42V27.83C222.58,30.4,223.81,31.34,226.41,31.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.24,34.09a45.35,45.35,0,0,1-5.59.58c-5.87,0-7.36-3.57-7.36-10.41,0-7.31,1.87-10.46,7.36-10.46a35.5,35.5,0,0,1,5.62.67l-.12,3s-3.51-.41-5-.41c-3.3,0-4.3,1.84-4.3,7.19,0,5.09.79,7.14,4.42,7.14,1.34,0,4.91-.38,4.91-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.61,14.12h13.68v3.3H260.2V34.35h-3.39V17.42h-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.71,14.12h3.45V34.35h-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.79,24.38c0-6.84,2.1-10.58,8-10.58s8,3.74,8,10.58-2.11,10.29-8,10.29S274.79,31.22,274.79,24.38Zm12.48,0c0-5-1.11-7.43-4.47-7.43s-4.48,2.43-4.48,7.43,1.09,7.13,4.48,7.13S287.27,29.44,287.27,24.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.63,14.12h5.76l6,16.66h.41V14.12h3.45V34.35h-5.65l-6.17-16.66h-.41V34.35h-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.91,34.35V14.12h3.39v17h7.51v3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336.34,34.35V14.12h3.4v17h7.51v3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.77,34.09a45.35,45.35,0,0,1-5.58.58c-5.88,0-7.37-3.57-7.37-10.41,0-7.31,1.87-10.46,7.37-10.46a35.3,35.3,0,0,1,5.61.67l-.12,3s-3.51-.41-5-.41c-3.3,0-4.29,1.84-4.29,7.19,0,5.09.79,7.14,4.41,7.14,1.35,0,4.91-.38,4.91-.38Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.46,47.46a2.13,2.13,0,0,1-1.59,2.21A2.32,2.32,0,0,1,83.6,52c0,2.08-1.56,2.78-3.53,2.78s-3.48-.66-3.48-2.63a2.53,2.53,0,0,1,1.65-2.48,2.21,2.21,0,0,1-1.49-2.22c0-1.64,1.32-2.45,3.32-2.45S83.46,45.8,83.46,47.46Zm-1,4.48c0-1.11-.72-1.47-1.67-1.74H79.31A1.76,1.76,0,0,0,77.76,52c0,1.31,1,1.75,2.31,1.75S82.43,53.33,82.43,51.94Zm-4.51-4.36c0,.87.46,1.33,1.39,1.66h1.45c1-.31,1.52-.77,1.52-1.65,0-1.13-.8-1.59-2.19-1.59S77.92,46.44,77.92,47.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.88,43.86a23.42,23.42,0,0,0-1.37,6.44,20.33,20.33,0,0,0,1.37,6.11H85.74a18.4,18.4,0,0,1-1.39-6.11,21.6,21.6,0,0,1,1.39-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.75,53.17a.91.91,0,0,0,.86.68l-.06.91a2.17,2.17,0,0,1-1.68-.56,6.36,6.36,0,0,1-2.45.56,2,2,0,0,1-2-2.19c0-1.35.81-2,2.2-2.14l2.11-.2v-.6c0-.92-.43-1.34-1.22-1.34a23.84,23.84,0,0,0-2.68.21l-.05-.92a21.35,21.35,0,0,1,2.77-.28c1.49,0,2.24.72,2.24,2.34Zm-3-1.93a1.2,1.2,0,0,0-1.24,1.3,1.17,1.17,0,0,0,1.08,1.31,6.45,6.45,0,0,0,2.14-.43V51.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.52,56.34a23.56,23.56,0,0,0,1.36-6.44,20.45,20.45,0,0,0-1.36-6.11h1.13A18.4,18.4,0,0,1,98,49.9a21.6,21.6,0,0,1-1.39,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.34,53.17a.92.92,0,0,0,.86.68l0,.91a2.16,2.16,0,0,1-1.68-.56,6.44,6.44,0,0,1-2.46.56,2,2,0,0,1-2-2.19c0-1.35.8-2,2.19-2.14l2.11-.2v-.6c0-.92-.43-1.34-1.22-1.34a23.84,23.84,0,0,0-2.68.21l0-.92a21.11,21.11,0,0,1,2.76-.28c1.5,0,2.24.72,2.24,2.34Zm-3-1.93a1.2,1.2,0,0,0-1.23,1.3,1.17,1.17,0,0,0,1.07,1.31,6.45,6.45,0,0,0,2.14-.43V51.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111,54.62V47.45h1.08v.47a5,5,0,0,1,2.11-.62c1.9,0,2.38,1.12,2.38,3.59v3.73h-1.06V50.91c0-1.77-.22-2.63-1.5-2.63a4.8,4.8,0,0,0-1.93.53v5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.28,54.62h-1.07v-.43a5,5,0,0,1-2,.57c-1.85,0-2.54-1.43-2.54-3.7,0-2.45.92-3.76,3-3.76a9.8,9.8,0,0,1,1.61.19V44.32h1.07Zm-1.07-1.33V48.41a10.41,10.41,0,0,0-1.55-.16c-1.39,0-2,1-2,2.84,0,1.64.44,2.71,1.61,2.71A5.18,5.18,0,0,0,123.21,53.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.28,50.09h-4.89v4.53H130.3v-10h1.09v4.43h4.89V44.64h1.09v10h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.31,53.7c1.55,0,2.38-.62,2.38-2.09v-7h1.09v7c0,2.18-1.14,3.14-3.47,3.14s-3.38-1-3.38-3.14v-7H141v7C141,53.07,141.84,53.7,143.31,53.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.78,44.64c1.81,0,3,.82,3,2.46a2.36,2.36,0,0,1-1.26,2.39A2.2,2.2,0,0,1,156,51.81c0,2-1.26,2.81-3.07,2.81h-3.63v-10Zm-2.35,1v3.44h2.41a1.63,1.63,0,0,0,1.76-1.83c0-1-.65-1.61-1.86-1.61Zm0,4.4v3.58h2.5a1.75,1.75,0,0,0,2-1.87c0-1.45-1.35-1.71-2.06-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.78,44.64h6.31V46l-5,7.32v.29h5v1h-6.31V53.3l5-7.34v-.29h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.81,51c0,2.34-.64,3.8-3,3.8s-3-1.34-3-3.83c0-2.32.74-3.63,3-3.63S171.81,48.65,171.81,51Zm-1.1,0c0-1.76-.51-2.71-1.88-2.71s-1.91.86-1.91,2.68.3,2.9,1.91,2.9S170.71,52.71,170.71,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174,54.62V47.45H175v.47a5,5,0,0,1,2.11-.62c1.91,0,2.38,1.12,2.38,3.59v3.73h-1.06V50.91c0-1.77-.22-2.63-1.49-2.63a4.82,4.82,0,0,0-1.94.53v5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187,53.69l0,.84a20.21,20.21,0,0,1-2.66.23c-2.11,0-2.85-1.39-2.85-3.68,0-2.56,1.13-3.78,2.95-3.78s2.81,1.1,2.81,3.36l0,.82h-4.61c0,1.32.43,2.34,1.83,2.34C185.47,53.82,187,53.69,187,53.69Zm-.79-3.06c0-1.7-.57-2.41-1.74-2.41s-1.85.75-1.86,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.42,54.48a19.2,19.2,0,0,1-2.66.28c-2.91,0-3.56-1.9-3.56-5.1s.69-5.17,3.56-5.17a15.2,15.2,0,0,1,2.67.3l-.06,1a21.33,21.33,0,0,0-2.49-.24c-2.17,0-2.54,1.45-2.54,4.12s.36,4.06,2.57,4.06a24.7,24.7,0,0,0,2.46-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.32,53.69l0,.84a20.21,20.21,0,0,1-2.66.23c-2.11,0-2.85-1.39-2.85-3.68,0-2.56,1.13-3.78,2.95-3.78s2.81,1.1,2.81,3.36l0,.82h-4.61c0,1.32.43,2.34,1.82,2.34C203.78,53.82,205.32,53.69,205.32,53.69Zm-.79-3.06c0-1.7-.57-2.41-1.74-2.41s-1.85.75-1.86,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.59,47.45h1.07v.95A6.86,6.86,0,0,1,211,47.3v1.12a8.14,8.14,0,0,0-2.38,1v5.24h-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.93,48.41v3.37c0,1.49.17,2,1,2,.4,0,1.16-.07,1.16-.07l.06.9a9.84,9.84,0,0,1-1.33.15c-1.42,0-2-.7-2-2.63V48.41h-1v-.95h1V45.25h1.08v2.21h2.15v.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.82,44.64h1.06v1.24h-1.06Zm0,2.81h1.06v7.17h-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.41,54.62h-1.06V48.4h-.88v-.95h.88V46.8c0-1.92.57-2.61,1.92-2.61.5,0,1.33.1,1.33.1v.89s-.69,0-1.1,0c-.81,0-1.08.47-1.08,1.68v.63h2.07v.95h-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M226,44.64h1.06v1.24H226Zm0,2.81h1.06v7.17H226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.48,53.69l0,.84a20,20,0,0,1-2.65.23c-2.11,0-2.85-1.39-2.85-3.68,0-2.56,1.13-3.78,2.95-3.78s2.81,1.1,2.81,3.36l0,.82H230.1c0,1.32.43,2.34,1.82,2.34C232.94,53.82,234.48,53.69,234.48,53.69Zm-.79-3.06c0-1.7-.58-2.41-1.74-2.41s-1.85.75-1.86,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242,54.62h-1.07v-.43a5,5,0,0,1-2,.57c-1.85,0-2.54-1.43-2.54-3.7,0-2.45.92-3.76,3-3.76a9.8,9.8,0,0,1,1.61.19V44.32H242Zm-1.07-1.33V48.41a10.41,10.41,0,0,0-1.55-.16c-1.4,0-2,1-2,2.84,0,1.64.44,2.71,1.6,2.71A5.26,5.26,0,0,0,240.91,53.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.68,49.47h2.7v5a28,28,0,0,1-3.16.31c-2.95,0-3.77-2-3.77-5.12s.82-5.15,3.74-5.15a19.28,19.28,0,0,1,3.19.35l0,1a22.29,22.29,0,0,0-3-.3c-2.23,0-2.72,1.46-2.72,4.11s.47,4.09,2.71,4.09a17,17,0,0,0,2-.19V50.45h-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.61,53.69l0,.84a20.17,20.17,0,0,1-2.65.23c-2.11,0-2.86-1.39-2.86-3.68,0-2.56,1.14-3.78,3-3.78s2.81,1.1,2.81,3.36l-.06.82h-4.6c0,1.32.43,2.34,1.82,2.34C260.08,53.82,261.61,53.69,261.61,53.69Zm-.79-3.06c0-1.7-.57-2.41-1.73-2.41s-1.85.75-1.87,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264,54.62V47.45h1.07v.47a5,5,0,0,1,2.11-.62c1.91,0,2.38,1.12,2.38,3.59v3.73H268.5V50.91c0-1.77-.22-2.63-1.49-2.63a4.82,4.82,0,0,0-1.94.53v5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277,53.69l0,.84a20.21,20.21,0,0,1-2.66.23c-2.11,0-2.85-1.39-2.85-3.68,0-2.56,1.13-3.78,2.95-3.78s2.81,1.1,2.81,3.36l-.05.82h-4.61c0,1.32.43,2.34,1.82,2.34C275.5,53.82,277,53.69,277,53.69Zm-.79-3.06c0-1.7-.58-2.41-1.74-2.41s-1.85.75-1.86,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.31,47.45h1.07v.95a6.86,6.86,0,0,1,2.38-1.1v1.12a8.14,8.14,0,0,0-2.38,1v5.24h-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.35,53.17a.92.92,0,0,0,.86.68l-.06.91a2.17,2.17,0,0,1-1.68-.56,6.36,6.36,0,0,1-2.45.56,2,2,0,0,1-2-2.19c0-1.35.81-2,2.2-2.14l2.11-.2v-.6c0-.92-.43-1.34-1.22-1.34a23.84,23.84,0,0,0-2.68.21l-.05-.92a21.35,21.35,0,0,1,2.77-.28c1.49,0,2.24.72,2.24,2.34Zm-3-1.93a1.2,1.2,0,0,0-1.23,1.3,1.17,1.17,0,0,0,1.07,1.31,6.45,6.45,0,0,0,2.14-.43V51.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.86,44.32h1.06v10.3h-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M304.52,54.48a19.2,19.2,0,0,1-2.66.28c-2.91,0-3.55-1.9-3.55-5.1s.68-5.17,3.55-5.17a15.2,15.2,0,0,1,2.67.3l-.06,1a21.33,21.33,0,0,0-2.49-.24c-2.17,0-2.54,1.45-2.54,4.12s.36,4.06,2.57,4.06a24.7,24.7,0,0,0,2.46-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312,51c0,2.34-.65,3.8-3,3.8s-3-1.34-3-3.83c0-2.32.75-3.63,3-3.63S312,48.65,312,51Zm-1.1,0c0-1.76-.51-2.71-1.88-2.71s-1.91.86-1.91,2.68.3,2.9,1.91,2.9S310.85,52.71,310.85,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.1,54.62V47.45h1.08v.47a5,5,0,0,1,2.11-.62c1.91,0,2.38,1.12,2.38,3.59v3.73h-1.06V50.91c0-1.77-.22-2.63-1.49-2.63a4.82,4.82,0,0,0-1.94.53v5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.37,48.41v3.37c0,1.49.18,2,1,2,.4,0,1.16-.07,1.16-.07l.06.9a10.08,10.08,0,0,1-1.34.15c-1.42,0-2-.7-2-2.63V48.41h-1v-.95h1V45.25h1.07v2.21h2.16v.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.35,47.45h1.08v.95a6.75,6.75,0,0,1,2.38-1.1v1.12a8,8,0,0,0-2.38,1v5.24h-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.39,53.17a.92.92,0,0,0,.86.68l-.05.91a2.16,2.16,0,0,1-1.68-.56,6.38,6.38,0,0,1-2.46.56,2,2,0,0,1-2-2.19c0-1.35.8-2,2.19-2.14l2.11-.2v-.6c0-.92-.43-1.34-1.22-1.34a23.84,23.84,0,0,0-2.68.21l0-.92a21.11,21.11,0,0,1,2.76-.28c1.5,0,2.24.72,2.24,2.34Zm-3-1.93a1.2,1.2,0,0,0-1.23,1.3,1.17,1.17,0,0,0,1.07,1.31,6.45,6.45,0,0,0,2.14-.43V51.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344.31,47.49l0,.92s-1-.12-1.58-.12c-1.56,0-2.06.81-2.06,2.62s.38,2.88,2.06,2.88c.55,0,1.59-.12,1.59-.12l0,.92a15.8,15.8,0,0,1-1.88.17c-2.24,0-2.93-1.19-2.93-3.85,0-2.46.86-3.61,2.94-3.61A12.85,12.85,0,0,1,344.31,47.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.45,48.41v3.37c0,1.49.17,2,1,2,.4,0,1.16-.07,1.16-.07l.06.9a10.08,10.08,0,0,1-1.34.15c-1.42,0-2-.7-2-2.63V48.41h-1v-.95h1V45.25h1.07v2.21h2.15v.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357,51c0,2.34-.64,3.8-3,3.8s-3-1.34-3-3.83c0-2.32.74-3.63,3-3.63S357,48.65,357,51Zm-1.1,0c0-1.76-.5-2.71-1.88-2.71s-1.91.86-1.91,2.68.31,2.9,1.91,2.9S355.86,52.71,355.86,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359,47.45h1.08v.95a6.86,6.86,0,0,1,2.38-1.1v1.12a8.14,8.14,0,0,0-2.38,1v5.24H359Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.89 25.11 16.89 25.11 21.1 31.21 41.22 0 0 0 0 59.71 2.72 59.71 16.03 39.06 6.89 25.11"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "33.82 49.66 33.82 26.88 26.23 38.65 33.82 49.66"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "51.15 0 34.9 25.2 42.16 25.2 42.16 45.38 53.95 45.38 53.95 54.11 36.89 54.11 33.89 54.11 25.89 54.11 21.04 46.7 12.64 59.71 60.81 59.71 60.81 0 51.15 0"
  })), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryLogo);
export default __webpack_public_path__ + "static/media/PrimaryLogo.6b8403b84229b86b6d35c61fdcd11ece.svg";
export { ForwardRef as ReactComponent };